import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IComboSelectBehavior } from "../../../../documaker/domain/format/objects";

export interface IComboSelectBehaviorPropertyEditable {
  comboSelectBehavior(): IPropertyEditable<IComboSelectBehavior>;
}

export function instanceOfIComboSelectBehaviorPropertyEditable(instance: any): instance is IComboSelectBehaviorPropertyEditable {
  return instance
      && instance.comboSelectBehavior
      && instanceOfIPropertyEditable<IComboSelectBehavior>(instance.comboSelectBehavior());
}
